import ArrayUtils from "../utils/ArrayUtils";
import { Component } from "./Component";
import ResizableScene from "./ResizableScene";

export class GameObject extends Phaser.GameObjects.Container {
	scene: ResizableScene;
	components: Component[];
	events: Phaser.Events.EventEmitter;

	// objects that aren't a child of this game object but are "attached" and should be removed when the object is removed.
	// e.g. spine animations
	attachments: (Phaser.GameObjects.Image | SpineGameObject)[] = [];

	constructor(scene: ResizableScene) {
		super(scene);
		this.scene = scene;
		this.components = [];
		this.events = new Phaser.Events.EventEmitter();
	}

	destroy(): void {
		for (const component of this.components) component.destroy();
		for (const attachment of this.attachments) attachment?.destroy();
		super.destroy();
	}

	update(dt: number): void {
		for (const component of this.components) {
			if (component.enabled) component.update(dt);
		}
	}

	physicsUpdate(dt: number): void {
		for (const component of this.components) {
			if (component.enabled) component.physicsUpdate(dt);
		}
	}

	preRender(): void {
		for (const component of this.components) {
			if (component.enabled) component.preRender();
		}
	}

	addComponent<T extends Component>(component: T): T {
		this.components.push(component);
		return component;
	}

	removeComponent<T extends Component>(component: T): void {
		component.destroy();
		ArrayUtils.remove(this.components, component);
	}

	getComponent<T extends new (...args: any) => InstanceType<T>>(Type: T): InstanceType<T> {
		return this.components.find((c) => c instanceof Type) as InstanceType<T>;
	}

	addImage(key: string): Phaser.GameObjects.Image {
		const img = this.scene.add.image(0, 0, key);
		this.add(img);
		return img;
	}
}
